import React from "react";
import "./CallToActionSection.css";
import { useNavigate } from "react-router-dom";

const CallToActionSection = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  return (
    <section className="home-cta-section">
      <h2 className="home-cta-heading">Drop your details, we’ll handle the rest.</h2>
      <button className="home-cta-button" onClick={handleContactClick}>
        Contact Us
      </button>
    </section>
  );
};

export default CallToActionSection;
